import { render, staticRenderFns } from "./modelerDesign.vue?vue&type=template&id=65d36c86"
import script from "./modelerDesign.vue?vue&type=script&lang=js"
export * from "./modelerDesign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports